export const REJECTED = 'rejected';
export const PENDING = 'pending';
export const VERIFIED = 'verified';
export const UNVERIFIED = 'unverified';
export const ACTION_REQUIRED = 'action_required';
export const ADDITIONAL_INFO_SUBMITTED = 'additional_info_submitted';
export const IMAGE_ISSUE = 'image_issue';
export const FAILED_VERIFY = 'failed_verify';
export const FAILED_KEY_VERIFY = 'failed_key_verify';
export const SCAN_ID_TYPE_NOT_SUPPORTED = 'scan_id_type_not_supported';
export const SCAN_NAME_MISMATCH = 'scan_name_mismatch';
export const SCAN_FAILED_GREYSCALE = 'scan_failed_greyscale';

// related to tokenization
export const ACCOUNT_NUMBER_INVALID = 'account_number_invalid';
export const ROUTING_NUMBER_INVALID = 'routing_number_invalid';
